<script>
import {NodeMixin} from '@/helpers/node-mixin';
import {TreeManager} from "@/services/tree-manager";
import {useStore} from "@/helpers/store-effect";

export default {
  name: 'ConditionNode',
  template: '#condition-node-template',
  mixins: [NodeMixin],
  emits: ['click'],
  setup(props) {
    const store = useStore();
    const addBranch = () => {
      TreeManager.addNode(store.workflow, props.node, 'branch');
    }

    const removeBranch = (branch) => {
      TreeManager.removeNode(store.workflow, props.node, branch)
    }

    return {
      addBranch,
      removeBranch
    }
  },
};
</script>
